<template>
  <Dialog
    width="540px"
    height="unset"
    titleAlign="left"
    :title="null"
    :subTitle="null"
    :visible="renderData.visible"
    hideCloseBtn
    @close="closeDialog"
    mobileRenderType="dialog"
    customClass="vip-publish-notification-dialog"
  >
    <div
      class="height-all go-to-publish-notification flex-column"
      :class="{
        'go-to-publish-notification--mobile': createRenderType == 'mobile',
      }"
    >
      <div class="gtpn-content">
        <div class="gtpn-close-btn" @click="closeDialog">
          <IconButton
            size="40px"
            icoSize="24px"
            @onClick="onClose"
            backgroundColor="rgba(0, 0, 0, 0)"
            hoverBackgroundColor="rgba(0, 0, 0, 0.1)"
          >
            <img src="../../../assets/img/close-dark-ico.png" />
          </IconButton>
        </div>
        <div class="gtpn-title">
          <div class="gtpn-title-bg"></div>
          <div class="gtpn-title-star-bg"></div>
          <div class="gtpn-title-text"></div>
        </div>

        <div class="gtpn-intro">
          {{$$t("create.release_notice_description")}}
        </div>

        <div class="gtpn-platforms">
          <picture>
            <source
              media="(min-width:768px)"
              srcset="@/assets/img/release/group_music_app.png"
            />
            <img src="@/assets/img/release/group_music_app_mobile.png" />
          </picture>
        </div>

        <div class="gtpn-more" @click="$router.push('/release')">
          {{$$t("create.learn_more")}}
        </div>
      </div>

      <div class="gtpn-footer">
        <p v-if="feedListStore.release?.item?.credit_type === 2">
          {{$$t("create.release_notice_exclusive_privilege_pro")}}
        </p>
        <p v-else>{{$$t("create.release_notice_subscribe_ownership")}}</p>
        <div class="gtpn-btn">
          <Button
            @click="onDoneClick"
            :renderStyle="{
              '--padding': '0 62px',
              '--width': 'max-content',
              '--height': '48px',
              '--borderRadius': '50px',
              '--fontColor': '#000',
              '--fontSize': '16px',
              '--fontWeight': 'bold',
              '--border': 'none',
              '--background':
                'linear-gradient(97deg, rgba(79, 222, 255, 1) 0%, rgba(230, 117, 255, 1) 99%)', //#94ADFF
              '--backgroundHover':
                'linear-gradient(120deg, rgb(79, 222, 255, 0.75) -1%, rgb(230, 117, 255, 0.75) 100%)',
              '--fontColorHover': '#000',
            }"
          >
            {{ $$t("create.unlock_membership") }}
          </Button>
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  reactive,
  watch,
  onMounted,
  getCurrentInstance,
} from "vue";

import { useRouter } from "vue-router";
import { $$language, $$t } from "@/i18n/i18n.js";
import useUserDataStore from "@/store/userDataStore";
import Dialog from "@/components/basic/dialog/Dialog.vue";
import Button from "@/components/basic/button/Button.vue";
import IconButton from "@/components/basic/button/IconButton.vue";

import { storeToRefs } from "pinia";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import useFeedListStore from "@/store/create/feedListDataStore.js";
import { checkSongReleaseStatus } from "@/api/api/apiStore.js";

const feedListStore = useFeedListStore();
const userDataStore = useUserDataStore();
const createLayoutStore = useCreateLayoutStore();
const { createRenderType } = storeToRefs(createLayoutStore);

const Router = useRouter();

const globalProperties =
  (getCurrentInstance() || (window?.$getVueCurrentInstance?.())).appContext?.config?.globalProperties;

const onDoneClick = async () => {
  globalProperties?.logClickEvent("release_ad_relase_subscribe", {
    entity: "ad_relase_subscribe",
    type: userDataStore.isLogin ? "sign_in" : "not_sign_in",
  });
  if (userDataStore.creditInfo.release_amount_left < 0) {
    message.warn({
      content: "You've used up all your release opportunities.",
      position: "top",
    });
    return;
  }
  const res = await checkSongReleaseStatus({
    song_id: feedListStore.release.item.song_id,
  });
  console.log(res);
  if (res.code === 200) {
    feedListStore.showReleaseFormDialog({
      ...res.data.release_info,
      release_state: res.data.release_state,
    });
  } else {
    feedListStore.closeReleaseDialog();
    Router.push({
      name: "subscribe",
      query: {
        membership_source1: "membership_feature",
        membership_source2: "release_pro",
      },
    });
  }
};

const closeDialog = () => {
  feedListStore.closeReleaseDialog();
};

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
});
const emits = defineEmits(["update:visible", "done", "complete"]);

const refUploadClipImage = ref(null);

const renderData = reactive({
  visible: props.visible,
});

const onClose = () => {
  renderData.visible = false;
  emits("update:visible", false);
  emits("cancel");
};

const goToTerms = () => {
  window.open(window.location.origin + "/terms", "_blank");
};

watch(
  () => props.visible,
  (val) => {
    renderData.visible = props.visible;
    renderData.filename = props.item?.title;
  }
);

watch(
  () => renderData.visible,
  (val) => {
    emits("update:visible", val);
  }
);

onMounted(() => {
  globalProperties?.logViewEvent("release_ad_relase", {
    entity: "ad_relase",
  });
});
</script>
<style lang="scss">
.custom-dialog.vip-publish-notification-dialog {
  .dialog-box {
    padding: 0;
    background: transparent !important;
  }
  .gtpn-content {
    border-radius: 20px;
    position: relative;
    background: linear-gradient(9deg, #e3faff 1%, #fbeaff 100%);
    padding: 0px 0px 16px 0px;
    max-width: 100%;
    .gtpn-close-btn {
      z-index: 10;
      cursor: pointer;
      position: absolute;
      right: 12px;
      top: 12px;
    }
    .gtpn-title {
      height: 184px;
      position: relative;
      margin-bottom: 80px;
      padding-top: 16px;
      .gtpn-title-bg {
        width: 240px;
        height: 240px;
        background-image: url("@/assets/img/publish-notification-top-bg.png");
        background-size: 100% 100%;
        margin: 0 auto;
      }
      .gtpn-title-star-bg {
        width: 382px;
        height: 66px;
        position: absolute;
        top: 20px;
        left: 96px;
        background-image: url("@/assets/img/release/stars.png");
        background-size: 100% 100%;
      }
      .gtpn-title-text {
        width: 412px;
        height: 88px;
        background-image: url("@/assets/img/publish-notification-top-text-cn.png");
        background-size: 100% 100%;
        position: absolute;
        top: 96px;
        left: calc(50% - 192px);
      }
    }
    .gtpn-intro {
      font-family: HarmonyOS Sans SC;
      font-size: 16px;
      font-weight: normal;
      line-height: 24px;
      text-align: center;
      color: rgba(0, 0, 0, 0.8);
      margin: 0 32px;
    }
    .gtpn-platforms {
      text-align: center;
      margin-top: 28px;

      img {
        width: 478px;
      }
      @media screen and (max-width: 768px) {
        img {
          width: 310px;
        }
      }
    }
    .gtpn-more {
      font-family: HarmonyOS Sans SC;
      font-size: 14px;
      font-weight: normal;
      line-height: 20px;
      text-align: center;
      color: #000000;
      text-decoration: underline;
      margin-top: 20px;
      cursor: pointer;

      &:hover {
        color: #94adff;
      }
    }
  }
  .gtpn-footer {
    margin: 24px 0 0 0;
    p {
      font-family: HarmonyOS Sans SC;
      font-size: 14px;
      font-weight: normal;
      line-height: 20px;
      text-align: center;
      color: #ffffff;
      margin: 0 0 16px 0;
    }
  }

  .go-to-publish-notification--mobile {
    .gtpn-title {
      .gtpn-title-text {
        width: 280px;
        height: 68px;
        left: calc(50% - 140px);
      }
    }
  }
}
</style>
